// extracted by mini-css-extract-plugin
export default {"wrap":"_p-z","logoContainer":"aq-z","brandImg":"bq-z","logoImg":"cq-z","logoButton":"dq-z"};